module.exports = __webpack_public_path__ + "static/media/Rainbow_Overjoyed.ac3529ee.gif";